<template>
  <f7-page class="no-swipeback" login-screen @page:reinit id="login" >
    <div class="body bgLogin">
      <b-row class="h-100">
        <div class="loginPanel loginHeight">
          <div>
            <div class="panel-heading ajust text-center mb-2rem">
              <b-navbar-brand href="#" class="p-3 col-7">
                <img :src="imgVarsLong" alt="MoneyRoad" class="heritage largescreen w-100">
                <!--<img :src="imgVarsShort" @click="loadAccueil" alt="MoneyRoad" class="heritage middlescreen">-->
              </b-navbar-brand>
              <h4 class="panel-title" v-if="activationCode">
                {{ $t('loginPage.sign_in_not_activated') }}
              </h4>
            </div>
            <div @keyup.enter="quickLogin()">
              <!--
              <b-row>
                <b-col cols="8" offset="2" class="form-group">
                  <form-write-group-label-input v-model="credentials.Login"
                    inputType="text"
                    :placeholderValue="loginpage_Identifier"
                    :customHeight="'25'"
                    inputLabel="Identifiant">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
              -->
              <!--DRO : Methode la plus simple pour régler le pb de l'affichage du mot de passe-->
              <b-row>
                <b-col cols="8" offset="2" class="form-group">
                  <form-write-group-label-input v-model="credentials.Login"
                    inputType="text"
                    :inputLabel="$t('common.identifier')"
                    inputClass="inputLogin">
                  </form-write-group-label-input>
                  <!-- <label>Identifiant</label>
                  <div class="form-control"
                    style="display:flex;height: 40px;">
                    <input v-model="credentials.Login"
                      inputType="text"
                      style="border:none;width: 100%;"
                      :placeholder="loginpage_Identifier">
                    </input>
                  </div> -->
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="8" offset="2" class="form-group">
                  <!-- <form-write-group-label-input v-model="credentials.Password"
                    isMandatory labelClass="mb-0"
                    inputType="password"
                    inputLabel="Mot de passe"
                    :inputIcon="[isPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                    :placeholderValue="loginpage_Password">
                  </form-write-group-label-input> -->
                  <div>
                    <label>{{$t('common.pwd')}}</label>
                    <div class="d-flex">
                      <input v-model="credentials.Password"
                        class="form-control inputAccordionForm inputLogin h-30px"
                        :type="passwordFieldType">
                      </input>
                      <i class="icon icon-password mt-2 pt-1"
                        :class="[isPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                        @click="toggleVisibility">
                      </i>
                    </div>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col v-if="withPassword" class="form-group">
                  <div class="form-control passwordControl d-flex h-25px">
                    <input v-model="credentials.PasswordRepeat" class="border-0 w-100"
                      :type="passwordFieldType"
                      :placeholder="loginpage_PasswordRepeat">
                    </input>
                    <i class="icon icon-password"
                      :class="[isPasswordFieldHidden ? 'fa-duotone fa-eye' : 'fa-duotone fa-eye-slash']"
                      @click="toggleVisibility">
                    </i>
                  </div>
                </b-col>
              </b-row>
              <!--<b-row v-if="!withPassword">
                <b-col cols="8" offset="2"  class="form-group p-0">
                  <a href="#" class="passwordForgot" @click="resetPassword" style="margin-left:20px;">Mot de passe oublié ?</a>
                </b-col>
              </b-row>-->
            </div>

            <b-row class="loginButtons">
              <b-col cols="8" offset="2">
                <b-button variant="primary" size="lg"
                  @click="authUser()">
                  {{ $t('loginPage.lgn_on_login_page') }}
                </b-button>
              </b-col>
            </b-row>
            <!-- <div class="login-method-separator">
              {{ $t('common.or_label_maj') }}
            </div> -->
            <!--<b-row class="loginButtons pt-3">
              <b-col cols="8" offset="2">
                <button class="loginGoogleButton  btn" size="lg"
                  @click="handleClickSignIn">
                  <div class="icon-google" style="display: inline-block;" v-if="false"></div>
                  <span style="vertical-align: middle; font-size: 13px;">
                    {{ $t('loginPage.login_ggl_sso') }}
                  </span>
                </button>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="text-center m-3">
                {{ $t('common.or_label_maj') }}
              </b-col>
            </b-row>
            <a class="signupLink" href="/register/">{{ $t('common.rgstr') }}</a>
            <cm-account-activation-popup :credentials="credentials">
            </cm-account-activation-popup>-->
          </div>
        </div>
      </b-row>
    </div>
  </f7-page>
</template>

<script>
import _ from 'underscore'
// import moment from 'moment'
import design from '@/design/design.json'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import CMAccountActivation from '@/popups/user/CMAccountActivation.vue'

import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'login',
  components: {
    'cm-account-activation-popup': CMAccountActivation,
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  props: {
    activationCodePassword: {
      default: 'notWithPassword',
      type: String
    }
  },
  data: () => {
    return {
      activationCode: '',
      connected: false,
      credentials: {
        Biometrics: {
          Voice: 'string',
          Video: 'string',
          Fingerprint: 'string'
        },
        ConnectBy: false,
        Login: '',
        Password: '',
        PasswordRepeat: ''
      },
      defaultService: 'Direct Debit',
      defaultUrl: '/home/',
      design: design.login,
      isLargeScreen: true,
      passwordFieldType: 'password',
      withPassword: false
    }
  },
  created () {
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isLargeScreen = false
    }
    this.$bus.$off('refresh-inbox-list-cache')
    this.activationCode = new URL(location.href).searchParams.get('activationCode')
    this.withPassword = new URL(location.href).searchParams.get('withPassword')
    if (this.withPassword === 'true') {
      this.withPassword = true
    } else {
      this.withPassword = false
    }
    if (!this.activationCode) {
      this.activationCode = ''
    }
    this.loginpage_Identifier = this.$i18n.t('common.enter_identifier')
    this.loginpage_PasswordRepeat = this.$i18n.t('common.conf_pwd')
    this.loginpage_UnvalidEmail = this.$i18n.t('errors.unvalid_email_adr')
    if (this.withPassword) {
      this.loginpage_Password = this.$i18n.t('common.new_pwd')
    } else {
      this.loginpage_Password = this.$i18n.t('common.enter_pwd')
    }
  },
  mounted () {
    if (!this.isLargeScreen) {
      this.$$('.navbar').addClass('deleteNavBar')
    }
    /* TLV 24/08/2020 Si l'utilisateur a déjà une session ouverte et n'est pas en
    * OTP, on le redirige vers la page d'accueil par défaut */
    if (this.$engine.auth.user.get().identifier !== '' && !location.href.includes('OTP')) {
      this.$$('.navbar').removeClass('deleteNavBar')
      this.$bus.$emit('login', true)
      loadPage(this, {url: this.defaultUrl})
    }
  },
  computed: {
    isPasswordFieldHidden () {
      return this.passwordFieldType === 'password'
    },
    imgVars () {
      return this.design.fontImage
    },
    imgVarsLong () {
      // console.log('design', this.design)
      return this.design.headbandLogoLong
    },
    imgVarsShort () {
      return this.design.headbandLogoShort
    }
  },
  methods: {
    connect () {
      /* TLV 18/08/2020
      * On précise ici le nom du service et son URL par défaut associées */
      let defaultServiceId = parseInt(this.$engine.services.getServiceIdByName(this.defaultService)) - 1
      let that = this
      this.$bus.emit('login', true)
      this.$bus.emit('service:change', this.defaultService)
      this.$bus.emit('refresh-cache-menu')
      this.$f7.hidePreloader()
      this.$$('.panel-overlay').css('z-index', '')
      this.$$('.deleteNavBar').removeClass('deleteNavBar')
      // let serviceInbox = '/inbox/0'
      // loadPage(that, {url: serviceInbox})
      // that.$f7.popup('#service-switcher-true')
      if (this.$engine.user.getIsFirstLogin() === '1') {
        this.$bus.emit('service:change', this.defaultService)
        // loadPage(that, {url: '/inbox/0'})
        this.$engine.services.payments.update(0, 1, 1,
          {
            statusWaiting: 1
          }
        )
        .then(resp => {
          // if (resp.data.payments.length > 0) {
          //   that.$engine.settings.set({clickedMessage: resp.data.payments[0]})
          //   that.$engine.settings.set({msgFromInbox: true})
          //   that.$engine.user.setIsFirstLogin('0')
          //   loadPage(that, {url: '/directPayments/transaction-details/0/'})
          // } else {
          //   loadPage(that, {url: '/directPayments/inbox/'})
          // }
          /* IRY 04/2020 A la première connexion, on est redirigé vers le dashboard */
          that.connected = true
          loadPage(that, {url: that.defaultUrl})
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      } else {
        that.connected = true
        loadPage(this, {url: '/home/'})
        // switch (this.$engine.user.get().favourite_service) {
          /*
          case '2' :
            this.$bus.emit('service:change', 'Direct Debit')
            loadPage(that, {url: '/directDebit/inbox/'})
            break
            */
          // default :
            // this.$engine.user.changeService(this.$engine.services.get()[defaultServiceId])
            // let that = this
            // const changeService = new Promise(function (resolve, reject) {
            //   loadPage(that, {url: that.defaultUrl})
            //   resolve()
            //   // that.$bus.emit('reload-app')
            // })
            // changeService.then(function () {
            //   that.$bus.emit('service:change', that.defaultService)
            // })
            // break
          // TLV 20/01/2020 : Pour la démo, la page d'accueil est la inbox des DP
          /* case '6' :
            this.$bus.emit('service:change', 'Direct Payments')
            loadPage(that, {url: '/directPayments/inbox/'})
            break
          default :
            this.$bus.emit('service:change', 'Payments')
            loadPage(that, {url: '/dashboard/'}) */
        // }
      }
    },
    authUser () {
      if (this.$$('.modal-in').length) {
        return
      }
      if (this.withPassword) {
        if (this.credentials.Login === '') {
          this.$f7.alert('Login missing', 'Error')
          return
        } else if (this.credentials.Password === '') {
          this.$f7.alert('Password missing', 'Error')
          return
        } else if (this.credentials.PasswordRepeat === '') {
          this.$f7.alert('Password confirm missing', 'Error')
          return
        } else if (this.credentials.Password !== this.credentials.PasswordRepeat) {
          this.$f7.alert('Passwords do not match', 'Error')
          return
        }
      }
      let that = this
      this.$f7.showPreloader(this.$t('loginPage.sign_in_loading'))
      const creds = _.clone(this.credentials)
      creds.ConnectBy = 'lpc'
      if (this.withPassword) {
        creds.WithPassword = '1'
      }
      this.$engine.auth.login(creds)
      .then(resp => {
        that.$engine.user.connectBy = 'login-password-capi'
        that.connect()
      })
      .catch(err => {
        that.$f7.hidePreloader()
        if (that.activationCode.length > 0) {
          this.activateAccount(that.activationCode)
        } else {
          errorMessageAlert(err, that)
        }
      })
    },
    quickLogin () {
      if (!this.connected && this.credentials.Login.length !== 0 && this.credentials.Password.length !== 0 && !this.$$('.modal-in').length) {
        this.authUser()
      }
    },
    activateAccount (code) {
      this.$f7.showPreloader('Activating account')
      let that = this
      if (code !== '') {
        this.$engine.auth.activate(code, this.withPassword, this.credentials.Password)
          .then(response => {
            that.$f7.closeModal()
            that.$f7.hidePreloader()
            that.status = response.status
            if (response.status === 200) {
              this.authUser()
            }
          }).catch(error => {
            that.$f7.hidePreloader()
            errorMessageAlert(error, that)
            // this.showModalActivationCode()
            // that.Dom7('.accountActivationInput2').val(code)
          })
      } else {
        that.$f7.hidePreloader()
        that.$f7.alert('Please enter a valid activation code', 'Incorrect')
        this.showModalActivationCode()
      }
    },
    resetPassword () {
      this.$f7.popup('#cm-user-reset-password-true')
    },
    sendAnotherCode () {
      let that = this
      this.$f7.showPreloader('Sending')
      this.$engine.auth.getNewActivationCode()
        .then(resp => {
          that.$f7.hidePreloader()
          that.$f7.alert('New activation code sent!', 'Ok')
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, this)
        })
    },
    showModalActivationCode () {
      let that = this
      that.$$('.blueConfirmationButtonActivationOK2').on('click')
      that.$f7.modal({
        title: 'Activate Account',
        text: 'Please enter your activation code',
        afterText: '<input class="accountActivationInput2" type="text"><p class="blueConfirmationButtonActivationOK2">OK</p>',
        buttons: [
          {
            text: 'Cancel',
            onClick: function () {
              that.$$('.blueConfirmationButtonActivationOK2').off('click')
            }
          },
          {
            text: 'Send new code',
            onClick: function () {
              that.sendAnotherCode()
              that.$$('.blueConfirmationButtonActivationOK2').off('click')
            }
          }
        ]
      })
      that.$$('.blueConfirmationButtonActivationOK2').on('click', function (e) {
        that.$f7.closeModal()
        that.activateAccount(that.Dom7('.accountActivationInput2').val())
      })
    },
    toggleVisibility ($event) {
      if (this.passwordFieldType === 'password') {
        this.passwordFieldType = 'text'
      } else {
        this.passwordFieldType = 'password'
      }
    },
    handleClickSignIn () {
      let that = this
      // On se conecte via Google
      this.$gAuth.signIn()
      .then(GoogleUser => {
        var gu = GoogleUser.getBasicProfile()
        var FirstName = gu.getGivenName()
        var LastName = gu.getFamilyName()
        var Login = gu.getEmail()
        var Password = gu.getId()
        this.$engine.user.connectBy = 'vue-google-oauth2'
        // est-ce qu'on est inscrit ? pour cela, on essait de se connecter
        that.$f7.showPreloader(this.$t('loginPage.sign_in_loading'))
        const creds = _.clone(that.credentials)
        creds.Login = Login
        creds.Password = Password
        creds.ConnectBy = 'vgo'
        this.$engine.auth.login(creds)
        .then(resp => {
          // J'existe
          this.connect()
        }).catch(() => {
          // On fail do something
          that.$f7.hidePreloader()
          this.$engine.auth.getLogin(Login, 'lpc')
          .then(() => {
            // Le compte existe en mode lpc.
            that.$f7.alert('The email sent by Google is already present in the database', 'Log in with your account')
          })
          .catch(err => {
            console.log(err)
            // console.log('/register/' + FirstName + '/' + LastName + '/' + Login + '/' + Password)
            loadPage(that, {url: '/register/' + FirstName + '/' + LastName + '/' + Login + '/' + Password})
          })
        })
      })
      .catch(err => {
        // On fail do something
        if (err === false) {
          this.connect()
        }
      })
    }
  }
}
</script>
